import React, { useEffect, useState } from "react";
import { Route, Switch, Link, withRouter } from "react-router-dom";
import { Menu } from "antd";
import GA4React from "ga-4-react";

//Components
import PrivateRoute from "../../components/PrivateRoute";

//Pages
import LoginPage from "../../pages/Login";
import HomePage from "../../pages/Home";
import SurveyHomePage from "../../pages/SurveyHome";
import GlobalRegionalSurveyHomePage from "../../pages/GlobalRegionalSurveyHome";
import PollHomePage from "../../pages/Poll/Home";
import GlobalRegionalPollHomePage from "../../pages/GlobalRegionalPoll/Home";
import PollChapterI from "../../pages/Poll/ChapterI";
import PollChapterII from "../../pages/Poll/ChapterII";
import PollChapterIII from "../../pages/Poll/ChapterIII";
import PollChapterIV from "../../pages/Poll/ChapterIV";
import PollPolicies from "../../pages/Poll/Policies";
import PollChapterV from "../../pages/Poll/ChapterV";
import ReportsPage from "../../pages/Reports";
import FilesPage from "../../pages/Files/List";
import FileFormPage from "../../pages/Files/Form";
import GlobalRegionalPollChapterI from "../../pages/GlobalRegionalPoll/ChapterI";
import GlobalRegionalPollChapterIII from "../../pages/GlobalRegionalPoll/ChapterIII";
import GlobalRegionalPollChapterV from "../../pages/GlobalRegionalPoll/ChapterV";

//Enum
import INTERNAL_LINKS from "../../enum/InternalLinks";
import "./style.scss";

const ga4react = new GA4React(process.env.REACT_APP_GOOGLE_ANALYTICS_CODE);

const Content = ({ history }) => {
  const [gaTag, setGaTag] = useState(null);
  const [isAuthenticated] = useState(
    window.localStorage.access_token !== undefined
  );

  useEffect(() => {
    ga4react.initialize().then(
      (ga4) => {
        setGaTag(ga4);
      },
      (err) => {
        console.error(err);
      }
    );

    history.listen((location) => {
      if (gaTag) {
        gaTag.pageview(location.pathname);
      }
    }).bind(this);
  }, []);

  return (
    <>
      <div className="app-container--content">
        {isAuthenticated && (
          <Menu mode="horizontal">
            <Menu.Item>
              <Link to={INTERNAL_LINKS.HOME}>Home / Inicio</Link>
            </Menu.Item>
            <Menu.Item>
              <Link to={INTERNAL_LINKS.SURVEY_HOME}>Surveys / Entrevistas</Link>
            </Menu.Item>
            <Menu.Item>
              <Link to={INTERNAL_LINKS.FILES}>Files / Archivos</Link>
            </Menu.Item>
            <Menu.Item>
              <Link to={INTERNAL_LINKS.REPORTS}>Reports / Reportes</Link>
            </Menu.Item>
          </Menu>
        )}
        <br></br>
        <Switch>
          <Route
            exact
            path={INTERNAL_LINKS.LOGIN}
            render={(props) => <LoginPage {...props} />}
          />
          <PrivateRoute
            exact
            path={INTERNAL_LINKS.HOME}
            render={(props) => <HomePage {...props} />}
          />
          <PrivateRoute
            exact
            path={INTERNAL_LINKS.SURVEY_HOME}
            render={(props) => <SurveyHomePage {...props} />}
          />
          <PrivateRoute
            exact
            path={INTERNAL_LINKS.GLOBAL_REGIONAL_SURVEY_HOME}
            render={(props) => <GlobalRegionalSurveyHomePage {...props} />}
          />
          <PrivateRoute
            exact
            path={`${INTERNAL_LINKS.POLL_HOME}/:id`}
            render={(props) => <PollHomePage {...props} />}
          />
          <PrivateRoute
            exact
            path={`${INTERNAL_LINKS.GLOBAL_REGIONAL_POLL_HOME}/:id`}
            render={(props) => <GlobalRegionalPollHomePage {...props} />}
          />
          <PrivateRoute
            exact
            path={`${INTERNAL_LINKS.POLL_CHAPTER_I}/:id/:lang`}
            render={(props) => <PollChapterI {...props} />}
          />
          <PrivateRoute
            exact
            path={`${INTERNAL_LINKS.POLL_CHAPTER_II}/:id/:lang`}
            render={(props) => <PollChapterII {...props} />}
          />
          <PrivateRoute
            exact
            path={`${INTERNAL_LINKS.POLL_CHAPTER_III}/:id/:lang`}
            render={(props) => <PollChapterIII {...props} />}
          />
          <PrivateRoute
            exact
            path={`${INTERNAL_LINKS.POLL_CHAPTER_IV}/:id/:lang`}
            render={(props) => <PollChapterIV {...props} />}
          />
          <PrivateRoute
            exact
            path={`${INTERNAL_LINKS.POLL_POLICIES}/:answer_id/:lang/:id?`}
            render={(props) => <PollPolicies {...props} />}
          />
          <PrivateRoute
            exact
            path={`${INTERNAL_LINKS.POLL_CHAPTER_V}/:id/:lang`}
            render={(props) => <PollChapterV {...props} />}
          />
          <PrivateRoute
            exact
            path={INTERNAL_LINKS.REPORTS}
            render={(props) => <ReportsPage {...props} />}
          />
          <PrivateRoute
            exact
            path={INTERNAL_LINKS.FILES}
            render={(props) => <FilesPage {...props} />}
          />
          <PrivateRoute
            exact
            path={`${INTERNAL_LINKS.FILE}/:id?`}
            render={(props) => <FileFormPage {...props} />}
          />
          <PrivateRoute
            exact
            path={`${INTERNAL_LINKS.GLOBAL_REGIONAL_POLL_CHAPTER_I}/:id/:lang`}
            render={(props) => <GlobalRegionalPollChapterI {...props} />}
          />
          <PrivateRoute
            exact
            path={`${INTERNAL_LINKS.GLOBAL_REGIONAL_POLL_CHAPTER_III}/:id/:lang`}
            render={(props) => <GlobalRegionalPollChapterIII {...props} />}
          />
          <PrivateRoute
            exact
            path={`${INTERNAL_LINKS.GLOBAL_REGIONAL_POLL_CHAPTER_V}/:id/:lang`}
            render={(props) => <GlobalRegionalPollChapterV {...props} />}
          />
        </Switch>
      </div>
      <div className="footer">
        <a
          without
          rel="noreferrer"
          target="_blank"
          href="http://www.mggroup.com.co"
        >
          Powered by MG GROUP Ltda.
        </a>
      </div>
    </>
  );
};

export default withRouter(Content);
